module.exports = __webpack_public_path__ + "static/media/izlozba (20).32dcc297.jpg";